import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    questions(data) {
        return axios.request({
            url: "mwap/questlist",
            method: "post",
            data
        });
    },
    submitQuestions(data) {
        return axios.request({
            url: "mwap/submitquests",
            method: "post",
            data
        });
    },
		
		getRankData(data){
			return axios.request({
			    url: "zgh/activity/qust-rank",
			    method: "get",
			    params: data,
			});
		},
		
		getRankData2(data){
			return axios.request({
			    url: "zgh/rank/sports",
			    method: "get",
			    params: data,
			});
		},
}
